import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverHorizontalRuleWithSpace() {
  return /*#__PURE__*/_jsx(HR, {
    distance: "flush",
    marginBlockStart: "300",
    marginBlockEnd: "400"
  });
}